// Generated from SVG to Code Figma Plugin

export const ProductElementLibrary = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_958_15703)">
      <path
        d="M6.36132 16.4714L3.65422 16.7251C2.70788 16.8139 1.87909 16.0944 1.83388 15.145L1.43704 6.81143C1.39468 5.92169 2.0594 5.15591 2.94626 5.07277L5.80577 4.80469"
        opacity="0.64"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        d="M14.1406 16.4714L16.8477 16.7251C17.7941 16.8139 18.6229 16.0944 18.6681 15.145L19.0649 6.81143C19.1073 5.92169 18.4426 5.15591 17.5557 5.07277L14.6962 4.80469"
        opacity="0.64"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <rect
        height="13.3333"
        width="8.88889"
        rx="1.66667"
        stroke="currentColor"
        strokeWidth="1.25"
        x="5.80469"
        y="3.80469"
      />
    </g>
    <defs>
      <clipPath id="clip0_958_15703">
        <rect height="20" width="20" fill="currentColor" transform="translate(0.25 0.46875)" />
      </clipPath>
    </defs>
  </svg>
);
